import React, { useEffect, useState } from "react";
import { Button, Card, Form, Nav, Navbar, Spinner } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {
    BrowserRouter as Router, Route, Switch, useRouteMatch
} from "react-router-dom";
import { db } from "../../../firebase";
import AdminSeason from "./season";


export default function AdminSeasons() {
    var [isAddSeason, setisAddSeason] = useState(false)
    var [newSeasonName, setnewSeasonName] = useState(null)
    var [isloading, setisloading] = useState(true)
    var [allSeasons, setallSeasons] = useState([])

    let match = useRouteMatch()

    function getAllSeasons() {
        setisloading(true)
        db.collection("seasons").get()
            .then((querySnapshot) => {
                var allSeasonsList = []
                querySnapshot.forEach((doc) => {
                    var seasonObj = doc.data()
                    seasonObj.id = doc.id
                    allSeasonsList.push(seasonObj)
                })
                console.log(allSeasonsList)

                setallSeasons(allSeasonsList)
                setisloading(false)
            })
            .catch((e) => {
                console.log(e)
                setisloading(false)
            })
    }

    function handleChange(e) {
        setnewSeasonName(e.target.value)
    }

    function handleAddSeason() {
        setisAddSeason(true)
    }

    function handleCancel() {
        setisAddSeason(false)
    }

    function handleSave() {
        // TODO : upload new season to firestore
        console.log("handleSave")
        setisloading(true)
        if (newSeasonName) {
            db.collection("seasons").add({ seasonName: newSeasonName })
                .then((docRef) => {
                    console.log("document written with ID : ", docRef.id)
                    setisloading(false)
                    setisAddSeason(false)
                })
                .catch((error) => {
                    console.error("Error adding document: ", error);

                    setisloading(false)
                    setisAddSeason(false)
                })
        }

        // TODO : trigger getAllSeason
        getAllSeasons()
    }

    useEffect(() => {
        getAllSeasons()
    }, [])


    let tabs = (
        allSeasons.map((doc, ind) =>
            <LinkContainer to={`${match.url}/${doc.id}`} key={ind}>
                <Nav.Link>
                    <b>{doc.seasonName}</b>
                </Nav.Link>
            </LinkContainer>
        )
    )

    let seasons = (
        <div id="seasons-container">
            <Navbar
                variant="dark"
                className="seasons-navbar"
            >

                <Navbar.Collapse>
                    <Nav className="flex-row"
                        navbarScroll>
                        <LinkContainer to={`${match.url}/`}>
                            <Nav.Link>
                                <b>Seasons</b>
                            </Nav.Link>
                        </LinkContainer>
                        {tabs}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            {isAddSeason ?
                <div>
                    <Card>
                        <Form>
                            <Form.Group>
                                <Form.Label>Season name</Form.Label>
                                <Form.Control onChange={handleChange}></Form.Control>
                            </Form.Group>
                        </Form>
                    </Card>
                    <Button variant="light" onClick={handleCancel}>Cancel</Button>
                    <Button onClick={handleSave}>Save</Button>
                </div>
                :
                <Button onClick={handleAddSeason}>+ add season</Button>
            }

        </div>
    )

    return (
        <div>
            <Router>
                <div>
                    {isloading ? <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                        :
                        seasons}
                </div>
                <Switch>
                    <Route path={`${match.url}/:id`}>
                        <AdminSeason reloadSeasons={getAllSeasons} />
                    </Route>
                </Switch>
            </Router>
        </div>
    )
}